export default "__VITE_ASSET__C8p4sSqz__"